import ButtonWithTooltip from 'common/components/ButtonWithTooltip'
import { Bin, Edit as EditIcon } from 'common/icons'

type Props = {
  name: string
  onClickEditName?: () => void
  onClickDeleteProduct?: () => void
}

const Actions = ({ name, onClickEditName, onClickDeleteProduct }: Props) => {
  return (
    <div className="flex gap-1">
      {onClickEditName && (
        <ButtonWithTooltip
          variant="icon"
          tooltip
          tooltipText="Update description"
          aria-label={`Edit product ${name}`}
          size="small"
          onClick={onClickEditName}
        >
          <div className="self-start">
            <EditIcon size={4} />
          </div>
        </ButtonWithTooltip>
      )}
      {onClickDeleteProduct && (
        <ButtonWithTooltip
          variant="icon"
          tooltip
          tooltipText="Delete product"
          aria-label={`Delete product ${name}`}
          size="small"
          onClick={onClickDeleteProduct}
        >
          <div className="self-start">
            <Bin size={4} />
          </div>
        </ButtonWithTooltip>
      )}
    </div>
  )
}

export default Actions
